import React from 'react'

export default () => (
  <svg viewBox="0 0 191.774 136.966">
    <defs>
      <linearGradient
        id="a"
        x1=".5"
        x2=".5"
        y1="1"
        gradientUnits="objectBoundingBox"
      >
        <stop offset="0" stopColor="gray" stopOpacity=".251" />
        <stop offset=".54" stopColor="gray" stopOpacity=".122" />
        <stop offset="1" stopColor="gray" stopOpacity=".102" />
      </linearGradient>
      <linearGradient id="b" x1=".5" x2=".5" y1="1" />
    </defs>
    <g data-name="Group 171" transform="translate(.037 -.003)">
      <path
        fill="#0047BA"
        d="M276.3,132.124c-4.439,9.156-13.451,15.279-22.791,19.316a86.639,86.639,0,0,1-40.077,6.682q-3.59-.239-7.158-.763a90.281,90.281,0,0,1-23.933-6.969q-3.3-1.485-6.462-3.242a82.663,82.663,0,0,1-10.1-6.605q-1.208-.922-2.382-1.891c-.543-.448-1.081-.905-1.627-1.35a20.532,20.532,0,0,0-3.662-2.494,13.081,13.081,0,0,0-1.226-.541c-4.19-1.594-9.021-.992-13.382.251-3.318.945-6.552,2.24-9.866,3.164a32.744,32.744,0,0,1-4.5.956,23.924,23.924,0,0,1-10.1-.887l-.279-.087q-.7-.221-1.392-.483l-.279-.107q-.668-.257-1.308-.553l-.279-.127q-.668-.311-1.308-.657c-.154-.08-.306-.167-.456-.249a27.341,27.341,0,0,1-6.542-5.093c-.055-.055-.107-.112-.167-.167-.266-.287-.526-.58-.778-.879-.094-.11-.187-.22-.279-.334q-.449-.548-.867-1.121c-.042-.055-.082-.112-.122-.167a24.154,24.154,0,0,1-2.816-5.093c-.023-.055-.045-.112-.065-.167q-.334-.86-.61-1.749c-.075-.247-.147-.5-.21-.748-.022-.074-.042-.149-.06-.222a45.186,45.186,0,0,1-1.027-11.156v-1.311a127.557,127.557,0,0,1,1.016-18.227.761.761,0,0,1,.018-.124,56.923,56.923,0,0,1,1.221-5.984,44.143,44.143,0,0,1,2.056-6.064,56.335,56.335,0,0,1,8.381-13.339C121.26,53.26,132.247,44.628,145.107,41.4a47.422,47.422,0,0,1,40.435,8.753c3.408,2.713,6.47,5.925,10.3,8.005,3.341,1.811,7.252,2.561,10.83,1.136a16.866,16.866,0,0,1,8.2-1.584,68.751,68.751,0,0,1,20.106,4.211c.261.1.521.194.78.292,16.824,6.436,31.285,19.224,38.8,35.657q.3.651.58,1.313C279.621,109.651,281.242,121.921,276.3,132.124Z"
        data-name="Path 431"
        opacity=".1"
        transform="translate(-87.592 -40.04)"
      />
      <ellipse
        cx="14.747"
        cy="2.369"
        fill="#6c63ff"
        data-name="Ellipse 56"
        opacity=".1"
        rx="14.747"
        ry="2.369"
        transform="translate(5.715 119.382)"
      />
      <ellipse
        cx="26.148"
        cy="2.539"
        fill="#6c63ff"
        data-name="Ellipse 57"
        opacity=".1"
        rx="26.148"
        ry="2.539"
        transform="translate(126.612 131.891)"
      />
      <rect
        width="158.754"
        height="89.929"
        fill="url(#a)"
        data-name="Rectangle 1172"
        rx="12.49"
        transform="translate(19.768 18.002)"
      />
      <rect
        width="158.267"
        height="88.365"
        fill="#fff"
        data-name="Rectangle 1173"
        rx="12.49"
        transform="translate(20.02 19.267)"
      />
      <rect
        width="158.267"
        height="88.365"
        fill="#fff"
        data-name="Rectangle 1174"
        rx="12.49"
        transform="translate(20.02 19.267)"
      />
      <rect
        width="158.267"
        height="88.365"
        fill="#fff"
        data-name="Rectangle 1175"
        opacity=".04"
        rx="12.49"
        transform="translate(20.02 19.267)"
      />
      <path
        fill="#5a5773"
        d="M302.084,149.29H145.424a.8.8,0,0,0-.8.8v3.4H302.881v-3.4a.8.8,0,0,0-.8-.8Z"
        data-name="Path 432"
        transform="translate(-124.6 -131.037)"
      />
      <g fill="#fff" transform="translate(22.095 19.267)">
        <circle cx="1.086" cy="1.086" r="1.086" data-name="Ellipse 58" />
        <circle
          cx="1.086"
          cy="1.086"
          r="1.086"
          data-name="Ellipse 59"
          transform="translate(2.923)"
        />
        <circle
          cx="1.086"
          cy="1.086"
          r="1.086"
          data-name="Ellipse 60"
          transform="translate(5.847)"
        />
      </g>
      <path
        fill="#0047BA"
        d="M0 0H42.473V3.605H0z"
        data-name="Rectangle 1176"
        opacity=".2"
        transform="translate(33.055 30.351)"
      />
      <path
        fill="#5a5773"
        d="M0 0H132.197V55.454H0z"
        data-name="Rectangle 1177"
        opacity=".1"
        transform="translate(33.055 44.806)"
      />
      <path
        d="M554.519,262.285h-2.264v-4.4a9.04,9.04,0,1,0-18.08-.122v4.519h-2.259a3.779,3.779,0,0,0-3.767,3.767v18.078a3.779,3.779,0,0,0,3.767,3.767h22.6a3.777,3.777,0,0,0,3.765-3.767V266.052A3.777,3.777,0,0,0,554.519,262.285Zm-9.981,11.752v6.475a1.351,1.351,0,0,1-1.253,1.356,1.321,1.321,0,0,1-1.383-1.32v-6.515a3.007,3.007,0,1,1,2.636,0Zm5.085-11.752H536.812v-4.519a6.4,6.4,0,1,1,12.806,0Z"
        data-name="Path 433"
        opacity=".1"
        transform="translate(-444.061 -213.863)"
      />
      <path
        fill="#0047BA"
        d="M554.519,260.285h-2.264v-4.4a9.04,9.04,0,1,0-18.08-.122v4.519h-2.259a3.779,3.779,0,0,0-3.767,3.767v18.078a3.779,3.779,0,0,0,3.767,3.767h22.6a3.777,3.777,0,0,0,3.765-3.767V264.052A3.777,3.777,0,0,0,554.519,260.285Zm-9.981,11.752v6.475a1.351,1.351,0,0,1-1.253,1.356,1.321,1.321,0,0,1-1.383-1.32v-6.515a3.007,3.007,0,1,1,2.636,0Zm5.085-11.752H536.812v-4.519a6.4,6.4,0,0,1,12.806,0Z"
        data-name="Path 434"
        transform="translate(-444.061 -212.197)"
      />
      <path
        fill="#5a5773"
        d="M0 0H13.381V3.159H0z"
        data-name="Rectangle 1178"
        opacity=".1"
        transform="translate(151.872 39.468)"
      />
      <path
        fill="url(#b)"
        d="M879.732,382.837a4.755,4.755,0,0,0-.448-1.271l-2-2.994h.012a5.048,5.048,0,0,1,0-2.242c.316-.738-1.126-2.554-1.126-2.554a1.077,1.077,0,0,1,.282-1.017c.458-.561-.282-2.205-.282-2.205s-.351-3.433-.386-3.957-.317-3.431-.317-3.431L874.794,357,873.6,340.67l-.022-.306c.147-.072.226-.117.226-.117l-.237-9.031.206-.185c1.794-1.624,5.932-5.382,5.89-5.464s-.5-6.276-.555-7.826a9.325,9.325,0,0,0-.712-3.2c-.1-.205-.4-1.56-.526-2.133-.033-.157-.055-.256-.055-.256s-1.213-2.312-1.108-3.363.316-1.838-2.27-2.205a10.021,10.021,0,0,1-3.465-1.208,9.856,9.856,0,0,0-2.482-1.243s-.725-1.336-1.229-.884a7.017,7.017,0,0,1-.476-1.488l-.015-.094a4.923,4.923,0,0,0,1.945-2.783c.017-.064.03-.129.045-.192a.541.541,0,0,0,.155.028c.439,0,.71-.489,1.121-.645.167-.065.373-.075.5-.207a.489.489,0,0,0,.11-.369.75.75,0,0,0,0-.137c0-.016,0-.032,0-.048v.017c-.112-.608-.583-1.148-.531-1.766.05-.581.561-1.092.52-1.659a.908.908,0,0,0-.012-.134v.02a1.43,1.43,0,0,0-.334-.591,1.9,1.9,0,0,0-.688-.578c-.232-.1-.5-.125-.718-.247-.638-.347-.636-1.253-1.016-1.871a1.655,1.655,0,0,0-1.549-.767c-.474.047-.9.3-1.373.381a3.591,3.591,0,0,1-1.9-.334,5.238,5.238,0,0,0-1.878-.5,1.594,1.594,0,0,0-1.557.951c-.105.334-.053.693-.134,1.032a2.248,2.248,0,0,1-1.211,1.323c-.334.185-.732.4-.835.748v-.027a.642.642,0,0,0-.017.085.623.623,0,0,0,0,.112,2.106,2.106,0,0,0,.212.7,1.926,1.926,0,0,1-.01,1.346c-.124.317-.334.6-.454.912a1.8,1.8,0,0,0-.11.458v-.027a1.824,1.824,0,0,0,0,.214,1.5,1.5,0,0,0,.167.7,1.259,1.259,0,0,0,.75.63c.334.077.543-.251.9-.167a1.406,1.406,0,0,1,.185.058c.012.075.023.15.037.224a4.91,4.91,0,0,0,1.694,2.868,1.065,1.065,0,0,0,.018.122h0a11.227,11.227,0,0,1,.139,2.015s-.526-.77-1.248.717a15.157,15.157,0,0,1-2.532,1.209c-.65.124-2.957.927-2.957.927a2.034,2.034,0,0,1-1.2.386c-.72,0-1.318,1.575-1.231,2.432s-.052,1.488-.722,1.523-.3,1.393-.3,1.417l-.062.292c-.13.6-.414,1.881-.514,2.081a9.355,9.355,0,0,0-.713,3.2c-.052,1.55-.5,7.721-.553,7.826-.035.068,2.8,2.659,4.793,4.47l.289.261-.917,8.566a2.287,2.287,0,0,0,.942,1.671c0,.1,0,.2-.01.307a10.712,10.712,0,0,1-.281,2.533,17.061,17.061,0,0,0-.211,3.572s-.282,6.127-.633,6.794a4.635,4.635,0,0,0-.317,2.339c.105.274-.353,7.633-.353,7.633l-.351,3.293s.105,3.151-.212,3.221-.493,2.242-.493,2.242-1.124,1.54-.633,2.1-.072.807-.124.946-1.072.668-.334,2.626a.578.578,0,0,0,.023.057c-.692.961-2.883,4.059-2.75,4.53a1.241,1.241,0,0,0,.585.7,3.418,3.418,0,0,0,2.81,0c2.339-.753,2.172-1.3,2.172-1.3a.992.992,0,0,1,.986-.945,2.768,2.768,0,0,0,1.689-.962l-.114-.423-.155-.585c.018-.167.137-.459.668-.621.81-.246.6-1.786.6-1.786s-.07-1.61.281-1.821.212-2.872.212-2.872a19.735,19.735,0,0,1,.949-3.222c.561-1.3,1.233-9,1.233-9a35.511,35.511,0,0,1,.879-4.868,27.551,27.551,0,0,0,.81-4.131s2.6-5.043,2.638-6.164c0,0,.334-1.051.668.105s1.273,3.922,1.273,3.922l.914,3.4,1.091,5.077.7,4.273a6.644,6.644,0,0,0,.167,2.172c.274.561.668,1.854.458,2.1s.421,1.4.6,1.645,0,5.427,0,5.427.809,4.412,1.97,5.179a1.419,1.419,0,0,0,.257.134c-.017.478-.033,1.118-.012,1.452a.556.556,0,0,0,.037.219,6.105,6.105,0,0,0,1.549,1.086c.247,0,1.124.613,1.161.91a9.742,9.742,0,0,0,2.93,1.594c.359.037,2.1.349,2.339-.14A.81.81,0,0,0,879.732,382.837Zm-6.226-63.1.18.155s.185,1.445.317,1.878a3.627,3.627,0,0,1-.027,1.275,2.934,2.934,0,0,0,.185.919c.157.316-.317,1-.317,1h-.423l-.132-5.409Zm-12.567-16.15v-.032a.107.107,0,0,0-.005.032Zm-6.49,20.823a.61.61,0,0,1-.027-.446,1.336,1.336,0,0,0,.089-.247,3.828,3.828,0,0,0,.1-.668.047.047,0,0,0,0-.008,3.532,3.532,0,0,1-.025-1.266c.125-.411.316-1.878.316-1.878l.12-.1.279-.242a1.98,1.98,0,0,1,.02-.239,18.6,18.6,0,0,1,.03,2.743,4.067,4.067,0,0,0-.528,1.557,6.388,6.388,0,0,1-.109,1.3A2.661,2.661,0,0,1,854.449,324.411Z"
        data-name="Path 435"
        transform="translate(-709.926 -247.642)"
      />
      <path
        fill="#c37098"
        d="M932.536,356.191v2.078l-4.263,2.143s-4.233-2.561-3.189-3.58c.668-.645.54-2.416.359-3.633h0c-.105-.708-.227-1.228-.227-1.228s7.6-2.172,6.455-.523a2.593,2.593,0,0,0-.286,1.971A8.952,8.952,0,0,0,932.536,356.191Z"
        data-name="Path 436"
        transform="translate(-774.549 -298.91)"
      />
      <path
        fill="#3f3d56"
        d="M864.767,439.125l-.55,6.769s-.824-.747-1.889-1.719c-1.976-1.8-4.783-4.38-4.749-4.449.052-.105.5-6.246.55-7.79a9.32,9.32,0,0,1,.7-3.187,19.813,19.813,0,0,0,.5-2.073c.04-.185.065-.306.065-.306l.922-.371s3.842,4.287,3.842,4.365-.262,3.371-.262,3.371l-.272.237-.119.1s-.184,1.438-.314,1.869a3.358,3.358,0,0,0,.025,1.26h0a3.886,3.886,0,0,1-.1.668,1.4,1.4,0,0,1-.089.246.614.614,0,0,0,.027.444,2.685,2.685,0,0,0,.287.55Z"
        data-name="Path 437"
        transform="translate(-718.458 -361.522)"
      />
      <path
        fill="#3f3d56"
        d="M1004.183,439.752c.04.082-4.058,3.822-5.833,5.438l-.805.73L997,439.15h1.412s.471-.68.314-.994a2.9,2.9,0,0,1-.182-.914,3.64,3.64,0,0,0,.025-1.268c-.13-.433-.314-1.869-.314-1.869l-.179-.154-.212-.185s-.262-3.293-.262-3.371,3.842-4.365,3.842-4.365l.915.366s.02.1.053.256c.124.57.419,1.918.521,2.123a9.322,9.322,0,0,1,.7,3.187C1003.682,433.506,1004.13,439.646,1004.183,439.752Z"
        data-name="Path 438"
        transform="translate(-834.589 -361.547)"
      />
      <path
        fill="#3f3d56"
        d="M1000.424,823.7c-.246.488-1.969.167-2.325.14a9.422,9.422,0,0,1-2.9-1.587c-.035-.3-.905-.905-1.149-.905a6.108,6.108,0,0,1-1.534-1.081.533.533,0,0,1-.035-.217c-.037-.573.035-2.048.035-2.048l5.053.279,2.456,3.694a4.761,4.761,0,0,1,.444,1.265.835.835,0,0,1-.042.461Z"
        data-name="Path 439"
        transform="translate(-830.814 -688.039)"
      />
      <path
        d="M1000.424,823.7c-.246.488-1.969.167-2.325.14a9.422,9.422,0,0,1-2.9-1.587c-.035-.3-.905-.905-1.149-.905a6.108,6.108,0,0,1-1.534-1.081.533.533,0,0,1-.035-.217c-.037-.573.035-2.048.035-2.048l5.053.279,2.456,3.694a4.761,4.761,0,0,1,.444,1.265.835.835,0,0,1-.042.461Z"
        data-name="Path 440"
        opacity=".1"
        transform="translate(-830.814 -688.039)"
      />
      <path
        d="M1000.474,833.91c-.246.488-1.97.167-2.325.14a9.423,9.423,0,0,1-2.9-1.587c-.035-.3-.905-.905-1.149-.905a6.108,6.108,0,0,1-1.534-1.081.533.533,0,0,1-.035-.217l1.637,1.036a6.906,6.906,0,0,1,1.325,1.064,9.481,9.481,0,0,0,2.659,1.236,12.518,12.518,0,0,1,2.367-.147A.835.835,0,0,1,1000.474,833.91Z"
        data-name="Path 441"
        opacity=".1"
        transform="translate(-830.863 -698.251)"
      />
      <path
        fill="#3f3d56"
        d="M856.423,821.557a2.734,2.734,0,0,1-1.671.957.984.984,0,0,0-.976.94s.167.541-2.143,1.291a3.377,3.377,0,0,1-2.783,0,1.243,1.243,0,0,1-.58-.7c-.157-.556,2.927-4.791,2.927-4.791L854,819.09l2,.905.307,1.148Z"
        data-name="Path 442"
        transform="translate(-710.701 -688.946)"
      />
      <path
        d="M856.423,821.557a2.734,2.734,0,0,1-1.671.957.984.984,0,0,0-.976.94s.167.541-2.143,1.291a3.377,3.377,0,0,1-2.783,0,1.243,1.243,0,0,1-.58-.7c-.157-.556,2.927-4.791,2.927-4.791L854,819.09l2,.905.307,1.148Z"
        data-name="Path 443"
        opacity=".1"
        transform="translate(-710.701 -688.946)"
      />
      <path
        fill="none"
        d="M859.342,831.761a2.734,2.734,0,0,1-1.671.957.984.984,0,0,0-.976.94s.167.541-2.143,1.291a3.377,3.377,0,0,1-2.783,0,17.107,17.107,0,0,0,4.51-1.255c.349-.349.785-1.308,1.081-1.325a11.638,11.638,0,0,0,1.876-1.031Z"
        data-name="Path 444"
        transform="translate(-713.62 -699.15)"
      />
      <path
        d="M859.342,831.761a2.734,2.734,0,0,1-1.671.957.984.984,0,0,0-.976.94s.167.541-2.143,1.291a3.377,3.377,0,0,1-2.783,0,17.107,17.107,0,0,0,4.51-1.255c.349-.349.785-1.308,1.081-1.325a11.638,11.638,0,0,0,1.876-1.031Z"
        data-name="Path 445"
        opacity=".1"
        transform="translate(-713.62 -699.15)"
      />
      <path
        fill="#3f3d56"
        d="M890.035,612.316a5.026,5.026,0,0,0,0,2.23s-4.677.244-5.82-.523-1.951-5.159-1.951-5.159.167-5.157,0-5.4-.8-1.393-.593-1.637-.167-1.534-.453-2.091a6.261,6.261,0,0,1-.167-2.16l-.7-4.253-1.079-5.052-.917-3.381s-.941-2.753-1.26-3.9-.657-.105-.657-.105c-.033,1.116-2.613,6.134-2.613,6.134a27.6,27.6,0,0,1-.8,4.111,35.674,35.674,0,0,0-.872,4.844s-.668,7.666-1.219,8.956a19.751,19.751,0,0,0-.93,3.206s.14,2.649-.209,2.858-.292,1.813-.292,1.813.209,1.532-.593,1.777-.668.767-.668.767-4.46.732-5.192-1.221.279-2.472.334-2.613.611-.383.124-.942.626-2.09.626-2.09.175-2.16.488-2.23.211-3.206.211-3.206l.347-3.276s.454-7.319.349-7.6a4.641,4.641,0,0,1,.314-2.339c.349-.668.626-6.762.626-6.762a16.982,16.982,0,0,1,.209-3.553,10.352,10.352,0,0,0,.277-2.521c.03-.757.037-1.383.037-1.383l3.9-1.463,5.012-1.6,4.216,2.021,6.169,1.184.077,1.064,1.178,16.256.668,6.132s.279,2.892.314,3.415.382,3.939.382,3.939.732,1.637.279,2.2a1.058,1.058,0,0,0-.279,1S890.349,611.585,890.035,612.316Z"
        data-name="Path 446"
        transform="translate(-722.795 -483.591)"
      />
      <path
        d="M933.175,351.45a2.593,2.593,0,0,0-.286,1.971,4.9,4.9,0,0,1-5.942-.222h0c-.105-.708-.227-1.228-.227-1.228S934.324,349.8,933.175,351.45Z"
        data-name="Path 447"
        opacity=".1"
        transform="translate(-776.049 -298.912)"
      />
      <path
        fill="#c37098"
        d="M927.189,317.364a4.871,4.871,0,1,1-1.427-3.468A4.895,4.895,0,0,1,927.189,317.364Z"
        data-name="Path 448"
        transform="translate(-768.286 -266.957)"
      />
      <path
        d="M895.091,349.979l-1.6,28.557-8.712-1.829-1.726-11.448,1.709-15.369,1.286.165,2.269.289,2.247.139,2.436-.271Z"
        data-name="Path 449"
        opacity=".1"
        transform="translate(-735.169 -291.438)"
      />
      <path
        fill="#0047BA"
        d="M895.091,351.237l-1.6,28.557-8.712-1.829-1.726-11.448,1.709-15.367,1.286.164,2.269.289,2.247.139,2.436-.271Z"
        data-name="Path 450"
        transform="translate(-735.169 -292.487)"
      />
      <path
        fill="#3f3d56"
        d="M939.23,396.3l3.137.105-.882,1.234a11.073,11.073,0,0,0,.481,3.209c.419.715.3,11.76.3,11.76l-.835,1.585L940,412.417l.018-14.584Z"
        data-name="Path 451"
        transform="translate(-786.47 -336.784)"
      />
      <path
        d="M939.23,396.3l3.137.105-.882,1.234a11.073,11.073,0,0,0,.481,3.209c.419.715.3,11.76.3,11.76l-.835,1.585L940,412.417l.018-14.584Z"
        data-name="Path 452"
        opacity=".1"
        transform="translate(-786.47 -336.784)"
      />
      <path
        d="M927.077,336.86,924.15,340.1l1.672,1.742,2.771-2.7Z"
        data-name="Path 453"
        opacity=".1"
        transform="translate(-769.403 -280.585)"
      />
      <path
        fill="#6c63ff"
        d="M927.077,335.61l-2.927,3.241,1.672,1.742,2.771-2.7Z"
        data-name="Path 454"
        transform="translate(-769.403 -279.543)"
      />
      <path
        d="M900.583,340.552l-2.964-2.962-.279,1.55,1.36,3.4Z"
        data-name="Path 455"
        opacity=".1"
        transform="translate(-747.072 -281.193)"
      />
      <path
        fill="#6c63ff"
        d="M901.211,339.3l-2.962-2.962-.279,1.55,1.36,3.4Z"
        data-name="Path 456"
        transform="translate(-747.597 -280.152)"
      />
      <path
        d="M907.186,576.85a14.46,14.46,0,0,1-4.51,1.3c-2.875.366-4.756-3.293-4.756-3.293l-1.1,1.428c-.349,1.517-5.663,1.9-7.823,1.325a3.457,3.457,0,0,1-1.24-.586c.03-.757.037-1.383.037-1.383l3.9-1.463,5.011-1.6,4.216,2.021,6.169,1.184Z"
        data-name="Path 457"
        opacity=".1"
        transform="translate(-743.598 -483.616)"
      />
      <path
        d="M922.044,391.279l-1.6,28.556-8.713-1.829L910,406.559l1.707-15.369,1.286.167a15.613,15.613,0,0,1-.189,1.671c-.209.977,1.081,7.912,1.081,7.912s2.451,7.776,3.553,6.655,2.673-7.04,2.673-7.04c1.064-2.2.018-8.353-.06-8.476a2.487,2.487,0,0,1-.1-.56Z"
        data-name="Path 458"
        opacity=".1"
        transform="translate(-762.122 -332.527)"
      />
      <path
        d="M998.275,507.816l.074,2.8-.805.73L997,504.57h1.2Z"
        data-name="Path 459"
        opacity=".1"
        transform="translate(-834.589 -426.967)"
      />
      <path
        d="M890.739,493.1h0a3.88,3.88,0,0,1-.1.668c0-.062,0-.1-.013-.1C890.58,493.653,890.64,493.4,890.739,493.1Z"
        data-name="Path 460"
        opacity=".1"
        transform="translate(-745.973 -417.413)"
      />
      <path
        d="M888.449,501.83l-.55,6.769s-.824-.747-1.889-1.719l.127-1.2s.449-2.947.613-4.4a2.687,2.687,0,0,0,.287.55Z"
        data-name="Path 461"
        opacity=".1"
        transform="translate(-742.14 -424.227)"
      />
      <path
        fill="#3f3d56"
        d="M878.133,375.041s-.521-.767-1.236.713a14.95,14.95,0,0,1-2.506,1.2c-.642.122-2.923.924-2.923.924a2.018,2.018,0,0,1-1.184.383c-.715,0-1.308,1.569-1.221,2.422s-.052,1.482-.713,1.517-.3,1.41-.3,1.41l4.409,5.053s.279,4.652.14,4.793a4.127,4.127,0,0,0-.523,1.55c.122.047-.668,5.192-.668,5.192l-1.062,9.985a2.526,2.526,0,0,0,2.162,2.247c2.162.576,7.479.2,7.821-1.321l1.1-1.43s1.881,3.66,4.756,3.294a13.825,13.825,0,0,0,4.706-1.412l-.314-11.966-.209-8.625,4.489-7.375s-1.2-2.3-1.1-3.341.312-1.829-2.249-2.2a9.833,9.833,0,0,1-3.433-1.2,9.81,9.81,0,0,0-2.456-1.236s-.718-1.336-1.218-.879a16.427,16.427,0,0,1,.459,2.172,7.189,7.189,0,0,0,.157,1.691c.078.132,1.124,6.281.06,8.476,0,0-1.562,5.919-2.673,7.04s-3.553-6.655-3.553-6.655-1.29-6.936-1.081-7.912S878.133,375.041,878.133,375.041Z"
        data-name="Path 462"
        transform="translate(-727.098 -318.749)"
      />
      <circle
        cx=".767"
        cy=".767"
        r=".767"
        fill="#3f3d56"
        data-name="Ellipse 61"
        transform="translate(153.997 77.603)"
      />
      <circle
        cx=".767"
        cy=".767"
        r=".767"
        fill="#3f3d56"
        data-name="Ellipse 62"
        transform="translate(153.997 81.218)"
      />
      <circle
        cx=".767"
        cy=".767"
        r=".767"
        data-name="Ellipse 63"
        opacity=".1"
        transform="translate(153.997 77.603)"
      />
      <circle
        cx=".767"
        cy=".767"
        r=".767"
        data-name="Ellipse 64"
        opacity=".1"
        transform="translate(153.997 81.218)"
      />
      <path
        stroke="#6c63ff"
        strokeMiterlimit="10"
        d="M992.47,804.34a20.487,20.487,0,0,1,3.46.488C996.242,805.072,992.47,804.34,992.47,804.34Z"
        data-name="Path 463"
        opacity=".1"
        transform="translate(-830.816 -676.66)"
      />
      <path
        stroke="#6c63ff"
        strokeMiterlimit="10"
        d="M880.3,789.53s.668.835.384,1.219S880.3,789.53,880.3,789.53Z"
        data-name="Path 464"
        opacity=".1"
        transform="translate(-737.384 -664.324)"
      />
      <path
        stroke="#6c63ff"
        strokeMiterlimit="10"
        d="M885.1,805.308s1.219-.8,1.707-.269S885.1,805.308,885.1,805.308Z"
        data-name="Path 465"
        opacity=".1"
        transform="translate(-741.382 -677.09)"
      />
      <path
        d="M927.205,317.373a4.871,4.871,0,0,1-.157,1.238.556.556,0,0,1-.324-.545c.022-.2.154-.381.125-.578-.042-.3-.409-.428-.6-.668a1.555,1.555,0,0,1-.167-1.089c.02-.376-.075-.835-.428-.964-.105-.038-.221-.042-.322-.085-.277-.117-.363-.461-.548-.7a1.444,1.444,0,0,0-1.671-.241,7.934,7.934,0,0,1-.752.314.982.982,0,0,1-.787-.058c-.11-.07-.2-.167-.312-.237a1.078,1.078,0,0,0-1.2.292,4.147,4.147,0,0,1-1,.864c-.185.084-.414.134-.5.314a.659.659,0,0,0-.053.312,9.344,9.344,0,0,1-.058,1.946c-.087.409-.374.874-.79.824a.776.776,0,0,1-.152-.038,4.895,4.895,0,1,1,9.706-.905Z"
        data-name="Path 466"
        opacity=".1"
        transform="translate(-768.302 -266.966)"
      />
      <path
        fill="#3f3d56"
        d="M907.552,300.956c.125.028.244.094.373.11.416.05.7-.414.79-.824a9.014,9.014,0,0,0,.06-1.946.637.637,0,0,1,.052-.312c.1-.18.324-.231.5-.314a4.328,4.328,0,0,0,1-.864,1.067,1.067,0,0,1,1.2-.292c.112.067.2.167.312.237a1,1,0,0,0,.788.058c.259-.077.5-.212.75-.314a1.451,1.451,0,0,1,1.671.239c.185.239.271.581.548.7.1.043.217.048.322.087.353.132.443.588.428.964a1.62,1.62,0,0,0,.167,1.089c.194.237.561.361.6.668.027.2-.1.381-.125.578a.555.555,0,0,0,.523.591c.434,0,.7-.486,1.109-.641a1.319,1.319,0,0,0,.5-.207.553.553,0,0,0,.1-.453c-.082-.64-.595-1.2-.54-1.838.052-.615.621-1.151.5-1.756a1.423,1.423,0,0,0-.334-.6,1.931,1.931,0,0,0-.682-.576,7.009,7.009,0,0,1-.713-.246c-.631-.346-.63-1.248-1-1.863a1.635,1.635,0,0,0-1.523-.758c-.469.047-.9.3-1.36.379a3.525,3.525,0,0,1-1.884-.334,5.153,5.153,0,0,0-1.859-.5,1.586,1.586,0,0,0-1.544.945c-.1.334-.052.692-.132,1.027a2.243,2.243,0,0,1-1.2,1.316c-.366.2-.805.438-.849.854a1.759,1.759,0,0,0,.209.757,1.926,1.926,0,0,1-.01,1.336c-.122.316-.326.593-.449.907a1.629,1.629,0,0,0,.043,1.336,1.246,1.246,0,0,0,.763.626C906.995,301.2,907.2,300.879,907.552,300.956Z"
        data-name="Path 467"
        transform="translate(-758.571 -249.924)"
      />
      <g data-name="Group 169" opacity=".1">
        <path
          d="M908.713,335.153c-.087.409-.376.874-.792.824-.129-.017-.246-.082-.373-.11-.349-.077-.556.251-.885.167a1.25,1.25,0,0,1-.765-.626,1.446,1.446,0,0,1-.155-.546,1.525,1.525,0,0,0,.155.86,1.249,1.249,0,0,0,.765.626c.334.077.536-.251.885-.167a3.784,3.784,0,0,0,.372.109c.416.052.705-.413.792-.822a4.83,4.83,0,0,0,.08-1.1A4.119,4.119,0,0,1,908.713,335.153Z"
          data-name="Path 468"
          transform="translate(-758.568 -285.2)"
        />
        <path
          d="M908.261,317.345a1.922,1.922,0,0,0-.11-.807,4.254,4.254,0,0,1-.192-.528.764.764,0,0,0-.017.085,1.79,1.79,0,0,0,.209.757A1.915,1.915,0,0,1,908.261,317.345Z"
          data-name="Path 469"
          transform="translate(-760.405 -269.907)"
        />
        <path
          d="M983.737,318.73c-.079.474-.463.92-.5,1.42a1.192,1.192,0,0,0,0,.257C983.319,319.824,983.835,319.308,983.737,318.73Z"
          data-name="Path 470"
          transform="translate(-823.118 -272.172)"
        />
        <path
          d="M975.314,339.83a.393.393,0,0,1-.1.187c-.124.132-.334.142-.5.207-.406.155-.668.646-1.109.641a.559.559,0,0,1-.5-.388.853.853,0,0,0-.023.11.555.555,0,0,0,.523.59c.436,0,.7-.486,1.109-.64.167-.065.371-.075.5-.207a.553.553,0,0,0,.1-.453C975.319,339.858,975.316,339.845,975.314,339.83Z"
          data-name="Path 471"
          transform="translate(-814.667 -289.748)"
        />
        <path
          d="M969.955,332.936c-.042-.3-.409-.428-.6-.668a.916.916,0,0,1-.184-.548,1.233,1.233,0,0,0,.184.862c.192.234.484.334.578.575A.537.537,0,0,0,969.955,332.936Z"
          data-name="Path 472"
          transform="translate(-811.402 -282.992)"
        />
        <path
          d="M931.432,317.866c.013-.376-.077-.835-.429-.964-.1-.038-.219-.043-.321-.085-.277-.117-.364-.461-.548-.7a1.447,1.447,0,0,0-1.671-.241c-.251.1-.489.237-.75.314a.982.982,0,0,1-.787-.058c-.11-.07-.2-.167-.312-.237a1.077,1.077,0,0,0-1.2.292,4.15,4.15,0,0,1-1,.864c-.187.084-.414.134-.511.314a.656.656,0,0,0-.052.312v.2a.475.475,0,0,1,.048-.194c.1-.18.324-.231.511-.314a4.326,4.326,0,0,0,1-.864,1.069,1.069,0,0,1,1.2-.292c.112.067.2.167.312.236a.975.975,0,0,0,.787.058,7.711,7.711,0,0,0,.75-.312,1.448,1.448,0,0,1,1.67.239c.184.237.271.581.548.7.1.043.217.048.321.087a.8.8,0,0,1,.424.745Z"
          data-name="Path 473"
          transform="translate(-773.657 -269.671)"
        />
      </g>
      <g data-name="Group 170" opacity=".1">
        <path
          d="M920,332.456a1.281,1.281,0,0,1,.966-1.2,4.009,4.009,0,0,1,2.252.1c1.585.525-.2,2.412-.2,2.412s-1.188,1.169-2.3.352a1.735,1.735,0,0,1-.646-1A2.56,2.56,0,0,1,920,332.456Z"
          data-name="Path 474"
          transform="translate(-770.449 -282.512)"
        />
        <path
          d="M952.856,332.457a1.281,1.281,0,0,0-.967-1.2,4.009,4.009,0,0,0-2.25.1c-1.585.525.2,2.412.2,2.412s1.186,1.169,2.3.352a1.736,1.736,0,0,0,.646-1A2.56,2.56,0,0,0,952.856,332.457Z"
          data-name="Path 475"
          transform="translate(-794.592 -282.513)"
        />
        <path
          d="M910.5,291.405v.079h2.9v-.094Z"
          data-name="Path 476"
          transform="translate(-758.033 -242.71)"
        />
        <path
          d="M942.6,334.236h.092v-.266a.76.76,0,0,1,.782,0v.237h.167v-.155h-.082s.033-.322-.511-.271c0,0-.438-.042-.428.236h-.1Z"
          data-name="Path 477"
          transform="translate(-789.21 -284.704)"
        />
      </g>
      <path
        fill="#0047BA"
        d="M920,331.81a1.281,1.281,0,0,1,.966-1.2,4.031,4.031,0,0,1,2.252.1c1.585.526-.2,2.412-.2,2.412s-1.188,1.169-2.3.352a1.725,1.725,0,0,1-.646-1,2.539,2.539,0,0,1-.075-.667Z"
        data-name="Path 478"
        transform="translate(-770.449 -281.975)"
      />
      <path
        fill="#0047BA"
        d="M952.856,331.81a1.281,1.281,0,0,0-.967-1.2,4.024,4.024,0,0,0-2.25.1c-1.585.526.2,2.412.2,2.412s1.186,1.169,2.3.352a1.726,1.726,0,0,0,.646-1A2.541,2.541,0,0,0,952.856,331.81Z"
        data-name="Path 479"
        transform="translate(-794.593 -281.975)"
      />
      <path
        fill="#6c63ff"
        d="M910.5,290.775v.08h2.9v-.1Z"
        data-name="Path 480"
        transform="translate(-758.034 -242.186)"
      />
      <path
        fill="#6c63ff"
        d="M942.6,333.608h.092v-.266a.765.765,0,0,1,.782,0v.239h.167v-.157h-.082s.033-.321-.511-.271c0,0-.438-.04-.428.236h-.1Z"
        data-name="Path 481"
        transform="translate(-789.21 -284.182)"
      />
      <path
        fill="#535461"
        d="M0 0H0.949V21.366H0z"
        data-name="Rectangle 1179"
        transform="translate(19.988 76.377)"
      />
      <path
        fill="#3f3d56"
        d="M121.593,617.552l-.06.962-.084,1.358-.035.566-.084,1.36-.037.566-.084,1.358-.957,15.447a2.616,2.616,0,0,1-2.611,2.456h-4.975a2.614,2.614,0,0,1-2.609-2.455l-.962-15.447-.084-1.358-.035-.566-.082-1.363-.035-.566-.084-1.358-.06-.962a1.355,1.355,0,0,1,1.353-1.438h10.172a1.353,1.353,0,0,1,1.351,1.442Z"
        data-name="Path 482"
        transform="translate(-94.693 -519.874)"
      />
      <path
        fill="#9d9cb5"
        d="M94.868,590.46l-.084,1.358H82.194l-.084-1.358Z"
        data-name="Path 483"
        transform="translate(-68.027 -491.821)"
      />
      <path
        fill="#9d9cb5"
        d="M95.34,601.98l-.084,1.36H82.905l-.085-1.36Z"
        data-name="Path 484"
        transform="translate(-68.618 -501.416)"
      />
      <path
        fill="#9d9cb5"
        d="M95.82,613.51l-.084,1.358H83.625l-.085-1.358Z"
        data-name="Path 485"
        transform="translate(-69.218 -511.02)"
      />
      <path
        fill="#0047BA"
        d="M39.6,524.1a24.631,24.631,0,0,1,7.828,10.252,24.67,24.67,0,0,1-12.195-4.226A24.546,24.546,0,0,1,27.41,519.87,24.652,24.652,0,0,1,39.6,524.1Z"
        data-name="Path 486"
        transform="translate(-26.97 -439.711)"
      />
      <path
        fill="none"
        stroke="#535461"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M27.46,519.87s6.913,3.842,9.129,7.016,10.885,7.464,10.885,7.464"
        data-name="Path 487"
        transform="translate(-27.012 -439.711)"
      />
      <path
        fill="#0047BA"
        d="M88.692,485.53a13.4,13.4,0,0,1,4.261,5.58,12.175,12.175,0,0,1-10.893-7.88A13.293,13.293,0,0,1,88.692,485.53Z"
        data-name="Path 488"
        transform="translate(-72.491 -409.192)"
      />
      <path
        fill="none"
        stroke="#535461"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M82.06,483.18s3.762,2.088,4.968,3.817,5.925,4.063,5.925,4.063"
        data-name="Path 489"
        transform="translate(-72.491 -409.15)"
      />
      <path
        fill="#0047BA"
        d="M152.566,504.423a18.52,18.52,0,0,0-4.186,8.758,16.836,16.836,0,0,0,12.512-13.752A18.523,18.523,0,0,0,152.566,504.423Z"
        data-name="Path 490"
        transform="translate(-127.732 -422.686)"
      />
      <path
        fill="none"
        stroke="#535461"
        strokeMiterlimit="10"
        strokeWidth="2"
        d="M160.892,499.43s-4.5,3.892-5.645,6.575-6.867,7.183-6.867,7.183"
        data-name="Path 491"
        transform="translate(-127.732 -422.686)"
      />
    </g>
  </svg>
)
